import clsx from 'clsx';

import SimpleCard from '../simple-card';
import VideoButton from '../video-button';

type Props = {
  title: string;
  description: string;
  imgSrc: string;
  textOnTheLeft?: boolean;
  videoId: string;
};

const CardWithVideo = ({ title, description, imgSrc, videoId, textOnTheLeft }: Props) => (
  <div className='grid h-min gap-4 lg:h-[330px] lg:grid-cols-2'>
    <SimpleCard className='h-[190px] xl:h-[330px]'>
      <VideoButton imgSrc={imgSrc} videoId={videoId} className='h-[190px] md:h-[190px] lg:h-[330px]' />
    </SimpleCard>
    <SimpleCard className={clsx(`lg:${textOnTheLeft ? 'order-first' : 'order-last'}`, 'flex flex-col justify-center px-6')}>
      <h3 className='text-main-blue pt-2.5 text-2xl font-normal'>{title}</h3>
      <p className='text-default py-2.5 text-base font-normal'>{description}</p>
    </SimpleCard>
  </div>
);

export default CardWithVideo;
